import { DirectiveOptions } from "vue";

// vue-multiselect renders its search input internally, so mark that input.
const directive: DirectiveOptions = {
  bind(el: HTMLElement) {
    const input = el.querySelector("input.multiselect__input");

    if (input) {
      input.setAttribute("data-1p-ignore", "");
    }
  },
};

export default directive;
